import { render, staticRenderFns } from "./droperror.vue?vue&type=template&id=0408fc52&scoped=true&"
import script from "./droperror.vue?vue&type=script&lang=js&"
export * from "./droperror.vue?vue&type=script&lang=js&"
import style0 from "./droperror.vue?vue&type=style&index=0&id=0408fc52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0408fc52",
  null
  
)

export default component.exports